/**
 * Created by scottrohrer on 7/20/15.
 */
define("logging/XMLLogger", [
    "jquery",
    "postal",
    "models/Vessel",
    "logging/XMLUtility"
], function ($, postal, VesselModel, XMLUtility) {
    XMLLogger = function (user, sessionID, destination) {
        this.eventNum = 0;

        this.user = user;
        this.sessionID = sessionID;
        this.destination = destination;
        this.eventOrigin = "IRYDIUM_VLAB";
        this.selectedFlask = null;
        this.selectedWorkbench = {cid: "c7"};
        this.isRubberBanding = false;
        var channel = postal.channel("logger");
        var subscriptions = [
            channel.subscribe("elementSelected", this.elementSelected.bind(this)),
            channel.subscribe("vlabInitialized", this.vlabInitialized.bind(this)),
            channel.subscribe("vlabProblemLoaded", this.vlabProblemLoaded.bind(this)),
            channel.subscribe("vlabUnknownsSet", this.vlabUnknownsSet.bind(this)),
            channel.subscribe("connectionMade", this.connectionMade.bind(this)),
            channel.subscribe("connectionBroken", this.connectionBroken.bind(this)),
            channel.subscribe("componentAdded", this.componentAdded.bind(this)),
            channel.subscribe("componentsRemoved", this.componentsRemoved.bind(this)),
            channel.subscribe("selectionChanged", this.selectionChanged.bind(this)),
            channel.subscribe("actionUsed", this.actionUsed.bind(this)),
            channel.subscribe("solutionChanged", this.solutionChanged.bind(this)),
            channel.subscribe("update", this.update.bind(this))
        ];

    };
    XMLLogger.prototype.log = function (description) {
        var array = [];
        var date = new Date();
        array.push(
            "<event>\n",
            "\t<id>" + this.eventNum++ + "</id>\n",
            "\t<user>" + this.user + "</user>\n",
            "\t<session>" + this.sessionID + "</session>\n",
            "\t<origin>" + this.eventOrigin + "</origin>\n",
            "\t<timestamp>" + date + "</timestamp>\n",
            XMLUtility.tabify(XMLUtility.tabify(description)).join(""),
            "</event>\n"
        );
        var string = array.join("");
        var destination = this.destination;
        if (destination === "console") {
            console.log(string);
        }
        else if (destination === "oli") {
            if (window.parent === window) {
                console.log("Destination is 'oli', but there is no parent. Logging to console.");
                console.log(string);
            } 
            else {
                // Post a message to the OLI parent window (listener is in our custom activity).
                window.parent.postMessage(string, "*")
            }
        } else if (destination === "svelte") {
            // What is the best way to give Svelte the data so it can be logged - directly use a POST method to the server?
            let post_data = {message: string, user_id: this.user, ses_id: this.sessionID};
            // Just use a browser native fetch here...
            fetch('/api/vlablog', 
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(post_data)
                }
            );
            
        }
        else {
            $.ajax({
                method: "POST",
                url: "tracer.php",
                data: "l="+string
            })
                .done(function(){console.log("logging success")})
                .fail(function(jqXHR, textStatus, errorThrown){console.log("logging fail: "+errorThrown)})
        }
    };
    XMLLogger.prototype.elementSelected = function (data) {
        this.selectedWorkbench = data.workbench;
    };
    XMLLogger.prototype.vlabInitialized = function (data) {
        var array = [];
        array.push(
            "<description type=\"VLAB_INIT\">\n",
            "\t<version>" + data.majorVersion + "." + data.minorVersion + "." + data.buildNumber + "</version>\n",
            "\t<readable>The Virtual Lab " + data.versionString + " is started.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.vlabProblemLoaded = function (data) {
        var array = [];
        array.push(
            "<description type=\"VLAB_LOAD_PROBLEM\">\n",
            "\t<file>" + data.path + "</file>\n",
            "\t<readable> The problem " + data.path + " is loaded.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.vlabUnknownsSet = function (data) {
        var array = [];
        array.push(
            "<description type=\"UNKNOWNMANAGER_SET_DATA\">\n",
            "\t<data>" + data.unknownString + "</data>\n",
            "\t<readable> The given unknowns data are set to: " + data.unknownString + "</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.connectionMade = function (data) {
        var comp1 = data.dependent;
        var comp2 = data.independent;
        var array = [];
        array.push(
            "<description type=\"WORKBENCH_CONNECT_COMPONENT\">\n",
            XMLUtility.tabify(XMLUtility.xmlWorkbench(this.selectedWorkbench)).join(""),
            XMLUtility.tabify(XMLUtility.xmlComponent(comp1)).join(""),
            XMLUtility.tabify(XMLUtility.xmlComponent(comp2)).join(""),
            "\t<readable>The " + XMLUtility.getName(comp1) + " (ID" + comp1.cid + ") is connected to the " + XMLUtility.getName(comp2) + " (ID" + comp2.cid + ").</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.connectionBroken = function (data) {
        var comp1 = data.dependent;
        var comp2 = data.independent;
        var array = [];
        array.push(
            "<description type=\"WORKBENCH_DISCONNECT_COMPONENT\">\n",
            XMLUtility.tabify(XMLUtility.xmlWorkbench(this.selectedWorkbench)).join(""),
            XMLUtility.tabify(XMLUtility.xmlComponent(comp1)).join(""),
            XMLUtility.tabify(XMLUtility.xmlComponent(comp2)).join(""),
            "\t<readable>The " + XMLUtility.getName(comp1) + " (ID" + comp1.cid + ") is disconnected to the " + XMLUtility.getName(comp2) + " (ID" + comp2.cid + ").</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.componentAdded = function (data) {
        this.selectedWorkbench = data.workbench;
        var component = data.component;
        var array = [];
        array.push(
            "<description type=\"WORKBENCH_ADD_COMPONENT\">\n",
            XMLUtility.tabify(XMLUtility.xmlWorkbench(this.selectedWorkbench)).join(""),
            XMLUtility.tabify(XMLUtility.xmlComponent(component)).join(""),
            "\t<readable>A " + XMLUtility.getName(component) + " (ID" + component.cid + ") is added to the workbench.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.componentsRemoved = function (data) {
        this.selectedWorkbench = data.workbench;
        var components = data.components;
        var i;
        for (i = 0; i < components.length; i++) {
            this.componentRemoved(components[i]);
        }
    };
    XMLLogger.prototype.componentRemoved = function (component) {
        var array = [];
        array.push(
            "<description type=\"WORKBENCH_REMOVE_COMPONENT\">\n",
            XMLUtility.tabify(XMLUtility.xmlWorkbench(this.selectedWorkbench)).join(""),
            XMLUtility.tabify(XMLUtility.xmlComponent(component)).join(""),
            "\t<readable> A " + XMLUtility.getName(component) + " (ID" + component.cid + ") is removed from the workbench.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.selectionChanged = function (data) {
        this.selectedWorkbench = data.workbench;
        var oldSelected = data.oldSelected;
        var selected = data.selected;
        if (this.isRubberBanding) {
            return;
        }
        var log = false;
        if (this.selectedFlask !== null && oldSelected.indexOf(this.selectedFlask) !== -1) {
            this.selectedFlask = null;
        }
        if (selected.length > 1) { // many components selected
            this.selectedFlask = null;
            log = false;
        }
        else if (selected.length === 1) { // 1 component selected
            var temp = selected[0];
            if (this.selectedFlask !== null) {
                if (temp instanceof VesselModel && temp.cid !== this.selectedFlask.cid) {
                    this.selectedFlask = temp;
                    log = true;
                }
            }
            else {
                this.selectedFlask = temp;
                log = true;
            }
        }
        else { // nothing selected
            log = false;
        }
        if (!log) {
            return;
        }
        var array = [];
        array.push(
            "<description type=\"WORKBENCH_SELECT_FLASK\">\n",
            XMLUtility.tabify(XMLUtility.xmlWorkbench(this.selectedWorkbench)).join(""),
            XMLUtility.tabify(XMLUtility.xmlFlask(this.selectedFlask)).join(""),
            "\t<readable>The " + XMLUtility.getName(this.selectedFlask) + " (ID" + this.selectedFlask.cid + ") is selected. The contained solution is: " + XMLUtility.oldLoggingFormat(this.selectedFlask.get("solution")) + "</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.actionUsed = function (data) {
        var name = data.name;
        var relevantInfo = data.relevantInfo;
        if (name === "PRECIPITATE") {
            this.solutionPrecipitated(relevantInfo);
        }
        else if (name === "FILTRATE") {
            this.solutionFiltrated(relevantInfo);
        }
        else if (name === "EVAPORATE") {
            this.solutionEvaporated(relevantInfo);
        }
    };
    XMLLogger.prototype.solutionPrecipitated = function (relevantInfo) {
        var source = relevantInfo.pre;
        var result = relevantInfo.post;
        var resultFlask = result.container;
        var array = [];
        array.push(
            "<description type=\"SOLUTION_PRECIPITATE\">\n",
            "\t<source>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(source))).join(""),
            "\t</source>\n",
            "\t<result>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(result))).join(""),
            "\t</result>\n",
            "\t<readable>The " + XMLUtility.getName(resultFlask) + " (ID" + resultFlask.cid + ") that contains " + source.name + " is filtrated to remove the liquid fraction.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.solutionEvaporated = function (relevantInfo) {
        var source = relevantInfo.pre;
        var result = relevantInfo.post;
        var resultFlask = result.container;
        var array = [];
        array.push(
            "<description type=\"SOLUTION_EVAPORATE\">\n",
            "\t<source>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(source))).join(""),
            "\t</source>\n",
            "\t<result>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(result))).join(""),
            "\t</result>\n",
            "\t<readable>The " + XMLUtility.getName(resultFlask) + " (ID" + resultFlask.cid + ") that contains " + source.name + " is evaporated to dryness.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.solutionFiltrated = function (relevantInfo) {
        var source = relevantInfo.pre;
        var result = relevantInfo.post;
        var resultFlask = result.container;
        var array = [];
        array.push(
            "<description type=\"SOLUTION_FILTRATE\">\n",
            "\t<source>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(source))).join(""),
            "\t</source>\n",
            "\t<result>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(result))).join(""),
            "\t</result>\n",
            "\t<readable>The " + XMLUtility.getName(resultFlask) + " (ID" + resultFlask.cid + ") that contains " + source.name + " is filtrated to remove the solid fraction.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.solutionChanged = function (se) {
        var result = se.source;
        var original = se.original;
        var other = se.other;
        var volume = se.volumeRequested;
        switch (se.eventType) {
            case "NAME":
                this.solutionRenamed(original, result);
                break;
            case "INSULATION":
                this.solutionInsulated(result);
                break;
            case "MIX":
                this.solutionMixed(original, other, result, volume);
                break;
            default:
                break;
        }
    };
    XMLLogger.prototype.solutionInsulated = function (result) {
        var id = this.selectedFlask.cid;
        var temp = result.getTemperature().toString();
        var insulated = result.insulated;
        var array = [];
        array.push(
            // Added solution properties to logging
            "<name><![CDATA[" + result.name + "]]></name>\n",
            "<temp scale=\"K\">" + result.getTemperature() + "</temp>\n",
            "<volume units=\"L\">" + result.getVolume() + "</volume>\n",
            // Thermal properties
            "<description type=\"SOLUTION_SET_THERMAL\">\n",
            "\t<id>" + id + "</id>\n",
            "\t<temp scale=\"K\">" + temp + "</temp>\n",
            "\t<insulated>" + insulated + "</insulated>\n",
            "\t<readable>The " + XMLUtility.getName(this.selectedFlask) + " (ID" + id + ") has been set to a temperature of " + temp + " K. The flask is now "
        );
        if (insulated) {
            array.push("insulated.</readable>\n");
        }
        else {
            array.push("not insulated.</readable>\n");
        }
        array.push("</description>\n");
        this.log(array);
    };
    XMLLogger.prototype.solutionMixed = function (recipient, source, result, volume) {
        var array = [];
        var sourceFlask = source.container;
        var resultFlask = result.container;
        array.push(
            "<description type=\"SOLUTION_MIX\">\n",
            "\t<volume units=\"L\">" + volume + "</volume>\n",
            "\t<source>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(source))).join(""),
            "\t</source>\n",
            "\t<recipient>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(recipient))).join(""),
            "\t</recipient>\n",
            "\t<result>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlFlask(result))).join(""),
            "\t</result>\n",
            "\t<readable>",
            volume + " L from " + XMLUtility.getName(sourceFlask) + " (ID" + sourceFlask.cid + ") that contains " + source.name + " " + XMLUtility.oldLoggingFormat(source),
            " is poured into " + XMLUtility.getName(resultFlask) + " (ID" + resultFlask.cid + ") that contains " + recipient.name + " " + XMLUtility.oldLoggingFormat(recipient),
            ". The resulting solution is " + XMLUtility.getName(resultFlask) + " (ID" + resultFlask.cid + ") that contains " + result.name + " " + XMLUtility.oldLoggingFormat(result) + ".</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.solutionRenamed = function (original, result) {
        var id = this.selectedFlask.cid;
        var oldName = original.name;
        var newName = result.name;
        var array = [];
        array.push(
            "<description type=\"SOLUTION_RELABEL\">\n",
            "\t<id>" + id + "</id>\n",
            "\t<old>\n",
            "\t\t<name><![CDATA[" + oldName + "]]></name>\n",
            "\t</old>\n",
            "\t<new>\n",
            "\t\t<name><![CDATA[" + newName + "]]></name>\n",
            "\t</new>\n",
            "\t<readable>The " + XMLUtility.getName(this.selectedFlask) + " (ID" + this.selectedFlask.cid + ") has been relabeled from " + oldName + " to " + newName + ".</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.update = function (data) {
        var observable = data.observable;
        var arg = data.arg;
        if (observable.get("tool").name === "Scale") {
            this.scaleTared(observable, arg);
        }
        else if (observable.get("tool").name === "Bunsen_Burner") {
            this.bunsenPowerChanged(observable);
        }
    };
    XMLLogger.prototype.scaleTared = function (scale, oldMass) {
        var array = [];
        array.push(
            "<description type=\"SCALE_TARE\">\n",
            XMLUtility.tabify(XMLUtility.xmlScale(scale)).join(""),
            "\t<old>\n",
            XMLUtility.tabify(XMLUtility.tabify(XMLUtility.xmlMass(oldMass))).join(""),
            "\t</old>\n",
            "\t<readable>The " + XMLUtility.getName(scale) + " (ID" + scale.cid + ") has been tared.</readable>\n",
            "</description>\n"
        );
        this.log(array);
    };
    XMLLogger.prototype.bunsenPowerChanged = function (burner) {
        var array = [];
        array.push(
            "<description type=\"BURNER_SET_POWER\">\n",
            "<component type=\"BURNER\">\n",
            "\t<id>" + burner.cid + "</id>\n",
            XMLUtility.tabify(XMLUtility.xmlBurner(burner)).join(""),
            "</component>\n",
            "<input>",
            burner.get("bunsenBurner").power + " kJ/s",
            "</input>\n",
            "</description>\n"
        );
        this.log(array);
    };
    return XMLLogger;
});
